import React from 'react';
import {Form} from 'react-bootstrap';
import { FilterPopover } from '../../components';

interface ISpecialToolFilterProps {
    specialTools: string[];
    checkedTools: boolean[];
    onCheckboxChange: (index: number) => void;
    topK: number;
    onNumberChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    t: (key: string) => string;
    handleApplyFilter: (event: React.FormEvent) => void;
    isLoading: boolean;
}

const SpecialToolFilter: React.FC<ISpecialToolFilterProps> = ({
                                                                  specialTools,
                                                                  checkedTools,
                                                                  onCheckboxChange,
                                                                  topK,
                                                                  onNumberChange,
                                                                  isLoading,
                                                                  handleApplyFilter,
                                                                  t,
                                                              }) =>
    (
        <FilterPopover
            id="special-tools-filter"
            title={t("OnlyMatchToOEM.FilterTitle")}
            isLoading={isLoading}
            onApplyFilter={handleApplyFilter}
            t={t}
        >
            <Form.Group>
                <Form.Label>{t("SpecialTool.SpecialTools")}</Form.Label>
                {specialTools.map((tool, index) => (
                    <Form.Check
                        aria-label={`option-${index}`}
                        key={index}
                        type="checkbox"
                        id={`tool-${index}`}
                        label={tool}
                        checked={checkedTools[index]}
                        onChange={() => onCheckboxChange(index)}
                        disabled={isLoading}
                    />
                ))}
            </Form.Group>
            <Form.Group>
                <Form.Label>{t("PdfFileUpload.TopKResults")}</Form.Label>
                <Form.Control
                    type="number"
                    value={topK}
                    onChange={onNumberChange}
                    disabled={isLoading}
                />
            </Form.Group>
        </FilterPopover>
    )

export default SpecialToolFilter;
